/**
 * Converts a Date to an ISO 8601 date string (YYYY-MM-DD) using the local timezone.
 * @param date The Date object to convert.
 * @returns The date in YYYY-MM-DD format, interpreted in the local timezone
 */
export const toLocalDateString = (date: Date): string => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    throw new Error('Invalid date passed to toLocalDateString');
  }
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
